import React from "react";

const Home = props => {
  return (
    <p>
      Marketing blurb about how great these snacks are. They're organic, home
      made, dogs love them, etc. This should be a little longer form content and
      there should be a few images mixed in showing baking, maybe shelly eating
      or something like that.
    </p>
  );
};

export default Home;
